import { RoleEnum } from "acl-cloud-lib";

export interface NavigationItem {
  text: string;
  path?: string;
  icon?: string;
  onlyForRoles?: RoleEnum[];
  items?: NavigationItem[];
}

export const navigation: NavigationItem[] = [
  {
    text: 'menu-dashboard',
    path: '/dashboard',
    icon: 'datatrending',
  },
  {
    text: 'menu-machines',
    icon: 'preferences',
    items: [
      {
        text: 'menu-machine',
        path: '/current-machine',
        icon: 'floppy',
      },
      {
        text: 'menu-list',
        path: '/machines',
        icon: 'bulletlist',
      },
    ]
  },
  {
    text: 'menu-colaboration',
    icon: 'group',
    items: [
      // {
      //   text: 'menu-ticket',
      //   path: '/colaboration/message'
      // },
      {
        text: 'menu-service-data',
        path: '/colaboration/service-data',
        icon: 'tableproperties'
      }
    ]
  },
  {
    text: 'menu-administration',
    icon: 'toolbox',
    onlyForRoles: [RoleEnum.SUPERADMIN],
    items: [
      {
        text: 'menu-trash',
        path: '/administration/trash',
        icon: 'trash',
      },
    ]
  },
];
